import React, { useRef } from 'react';
import { Transition as ReactTransitionGroup } from 'react-transition-group';

interface Style {
  [key: string]: string | number;
}

interface Style {}

interface Props {
  duration: number;
  children: any;
  show: boolean;
  transitionStyles: {
    [key: string]: Style;
  };
  defaultStyle: Style;
  unmountOnExit?: boolean;
  mountOnEnter?: boolean;
}

function Transition({ duration, children, show, defaultStyle, transitionStyles, unmountOnExit, mountOnEnter }: Props) {
  const nodeRef = useRef(null);

  return (
    <ReactTransitionGroup nodeRef={nodeRef} in={show} timeout={duration} unmountOnExit={unmountOnExit} mountOnEnter={mountOnEnter}>
      {(state) =>
        React.Children.map(children, (child) =>
          React.cloneElement(child, {
            ref: nodeRef,
            style: { ...defaultStyle, ...transitionStyles[state as keyof typeof transitionStyles] },
          })
        )
      }
    </ReactTransitionGroup>
  );
}

export default Transition;
